import React, { useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import styles from "./File.module.sass";
import { getCroppedImg } from "./utils";
import { Range, getTrackBackground } from "react-range";
import useDarkMode from "use-dark-mode";
import Card from "../../components/Card";
import { useUser } from "../../context";
import common from "../../i11/Common";

const STEP = 0.01;
const MIN = 1;
const MAX = 3;

const CropperComponent = ({ setImage, onClose, image, aspect_ratio }) => {
	const { locale } = useUser();
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState([1]);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
	const darkMode = useDarkMode(false);

	const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
		setCroppedAreaPixels(croppedAreaPixels);
	}, []);

	const showCroppedImage = useCallback(async () => {
		try {
			const croppedImage = await getCroppedImg(image, croppedAreaPixels);
			console.log([croppedImage]);
			setImage([croppedImage]);
			onClose();
		} catch (e) {
			console.error(e);
		}
	}, [croppedAreaPixels]);

	return (
		<Card title={common[locale].crop_image} classTitle="title-green">
			<div className={styles.cropWrap}>
				<Cropper
					image={image}
					crop={crop}
					zoom={zoom[0]}
					aspect={aspect_ratio}
					onCropChange={setCrop}
					onCropComplete={onCropComplete}
					onZoomChange={(e) => setZoom([e])}
				/>
			</div>
			<Range
				values={zoom}
				step={STEP}
				min={MIN}
				max={MAX}
				onChange={(values) => setZoom(values)}
				renderTrack={({ props, children }) => (
					<div
						onMouseDown={props.onMouseDown}
						onTouchStart={props.onTouchStart}
						style={{
							...props.style,
							height: "36px",
							display: "flex",
							width: "100%",
						}}
					>
						<div
							ref={props.ref}
							style={{
								height: "4px",
								width: "100%",
								borderRadius: "2px",
								background: getTrackBackground({
									values: zoom,
									colors: darkMode.value
										? ["#272B30", "#2A85FF", "#272B30"]
										: ["#EFEFEF", "#2A85FF", "#EFEFEF"],
									min: MIN,
									max: MAX,
								}),
								alignSelf: "center",
							}}
						>
							{children}
						</div>
					</div>
				)}
				renderThumb={({ props, isDragged }) => (
					<div
						{...props}
						style={{
							...props.style,
							height: "12px",
							width: "12px",
							borderRadius: "4px",
							backgroundColor: "#FFF",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							boxShadow: "0px 2px 6px #AAA",
						}}
					>
						<div
							style={{
								height: "5px",
								width: "5px",
								backgroundColor: isDragged ? "#548BF4" : "#CCC",
							}}
						/>
					</div>
				)}
			/>
			<div className={styles.cropFoot}>
				<button onClick={showCroppedImage} type="button" className="button">
					{common[locale].confirm}
				</button>
			</div>
		</Card>
	);
};

export default CropperComponent;
